module.exports = __webpack_public_path__ + "img/symbol_4.e1c8b7ff.png";